import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Api from '../Api/Api.json';

const ConsultDoctor = () => {
    const navigate = useNavigate();
    const [selectedSpeciality, setSelectedSpeciality] = useState('');
    const [selectedDesignation, setSelectedDesignation] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [doctors, setDoctors] = useState([]);
    const [error, setError] = useState('');
    const [showAppointmentDialog, setShowAppointmentDialog] = useState(false);

    // Designations from the reference file
    const designations = [
        "Professor", 
        "Associate Professor", 
        "Assistant Professor", 
        "Senior Consultant", 
        "Junior Consultant", 
        "Consultant", 
        "Medical Officer"
    ];

    // Specialities from the reference file
    const specialities = [
        "Andrologist & Lap Surgeon",
        "Cardiology",
        "Cardio-Vascular Surgery",
        "Chest Diseases",
        "COVID-19(Coronavirus)",
        "Dentist",
        "Dermatology",
        "Diabetes & Hormone",
        "Dietician",
        "ENT",
        "EYE",
        "Gastroenterology",
        "General Physician",
        "General Surgery",
        "Gynae & Gynaeoncology",
        "Gynaecology & Infertility",
        "Haematology",
        "Medicine",
        "Nephrology (Nephrologist & Medical Specialist)",
        "Neurologist",
        "Neurosurgeon & Spine Surgeon",
        "Nutrition (Overweight, child nutrition & diet therapy)",
        "Nutrition Consultant",
        "Onclogy (Cancer)",
        "Orthopaedic",
        "Paediatrician & Paediatric cardiology",
        "Pain Medicine",
        "Pediatrics & Neonate (Child)",
        "Physical Medicine",
        "Physiotherapy",
        "Plastic Surgery",
        "Psychiatrist",
        "Respiratory Medicine",
        "Skin & VD",
        "Urologist",
        "Vascular Surgery"
    ];

    const handleSearch = async () => {
        if (!selectedSpeciality && !selectedDesignation) {
            setError('Please select at least one speciality or designation');
            return;
        }

        setIsLoading(true);
        setError('');
        setDoctors([]);

        try {
            const body = {
                task: 'getDocList',
                speciality: selectedSpeciality,
                designation: selectedDesignation
            };

            const headers = { 
                headers: { "Content-Type": "application/json" } 
            };

            const response = await axios.post(Api.PATIENT_API, body, headers);
            
            console.log('API Response:', response.data);
            
            if (response.data) {
                setDoctors(response.data);
            } else {
                setError('No doctors found with the selected criteria');
            }
        } catch (err) {
            console.error('Error fetching doctors:', err);
            setError('Failed to fetch doctors. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleReset = () => {
        setSelectedSpeciality('');
        setSelectedDesignation('');
        setDoctors([]);
        setError('');
    };

    return (
        <div className="min-h-screen bg-gray-50 pt-14 pb-6">
            {/* Header */}
            <div className="max-w-4xl mx-auto px-4">
                <div className="mb-6">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center text-gray-600 hover:text-blue-600 transition-colors duration-200 mb-4"
                    >
                        <svg
                            className="w-5 h-5 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 19l-7-7 7-7"
                            />
                        </svg>
                        <span className="text-sm font-medium">ফিরে যান</span>
                    </button>
                    
                    <h1 className="text-2xl font-bold text-gray-900 mb-2">
                        ডাক্তার দেখান
                    </h1>
                    <p className="text-gray-600">
                        আপনার প্রয়োজন অনুযায়ী বিশেষজ্ঞ এবং পদবি নির্বাচন করুন
                    </p>
                </div>

                {/* Search Form */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Speciality Selection */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                বিশেষজ্ঞতা নির্বাচন করুন
                            </label>
                            <select
                                value={selectedSpeciality}
                                onChange={(e) => setSelectedSpeciality(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="">সব বিশেষজ্ঞতা</option>
                                {specialities.map((speciality, index) => (
                                    <option key={index} value={speciality}>
                                        {speciality}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Designation Selection */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                পদবি নির্বাচন করুন
                            </label>
                            <select
                                value={selectedDesignation}
                                onChange={(e) => setSelectedDesignation(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="">সব পদবি</option>
                                {designations.map((designation, index) => (
                                    <option key={index} value={designation}>
                                        {designation}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-3 mt-6">
                        <button
                            onClick={handleSearch}
                            disabled={isLoading}
                            className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                        >
                            {isLoading ? (
                                <div className="flex items-center justify-center">
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                    অনুসন্ধান করছে...
                                </div>
                            ) : (
                                'ডাক্তার খুঁজুন'
                            )}
                        </button>
                        
                        <button
                            onClick={handleReset}
                            className="flex-1 bg-gray-200 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                        >
                            রিসেট করুন
                        </button>
                    </div>

                    {/* Error Message */}
                    {error && (
                        <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-md">
                            <div className="flex items-center">
                                <svg className="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                </svg>
                                <span className="text-red-800">{error}</span>
                            </div>
                        </div>
                    )}
                </div>

                {/* Results Section */}
                {doctors.length > 0 && (
                    <div className="bg-white rounded-lg shadow-md p-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">
                            পাওয়া ডাক্তার ({doctors.length})
                        </h2>
                        
                        <div className="space-y-4">
                            {doctors.map((doctor, index) => (
                                <div key={index} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow duration-200">
                                    <div className="flex items-start justify-between">
                                        <div className="flex-1">
                                            <div className="flex items-center gap-2 mb-1">
                                                <h3 className="text-lg font-medium text-gray-900">
                                                    {doctor.name || 'ডাক্তারের নাম নেই'}
                                                </h3>
                                                {doctor.gender && (
                                                    <span className={`px-2 py-1 text-xs rounded-full ${
                                                        doctor.gender.toLowerCase() === 'male' || doctor.gender === 'M'
                                                            ? 'bg-blue-100 text-blue-800' 
                                                            : 'bg-pink-100 text-pink-800'
                                                    }`}>
                                                        {(doctor.gender === 'Male' || doctor.gender === 'M') ? 'পুরুষ' : 'মহিলা'}
                                                    </span>
                                                )}
                                            </div>
                                            <p className="text-sm text-gray-600 mb-1">
                                                {doctor.designation || 'পদবি নেই'}
                                            </p>
                                            <p className="text-sm text-gray-600 mb-2">
                                                {doctor.speciality || 'বিশেষজ্ঞতা নেই'}
                                            </p>
                                            {doctor.hospital && (
                                                <p className="text-sm text-gray-500 mb-2">
                                                    {doctor.hospital}
                                                </p>
                                            )}
                                            {doctor.first_visit_rate && (
                                                <div className="flex items-center gap-2">
                                                    <span className="text-sm font-medium text-green-600">
                                                        প্রথম পরিদর্শন:
                                                    </span>
                                                    <span className="text-sm text-gray-700">
                                                        ৳{doctor.first_visit_rate}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="ml-4 flex flex-col gap-2">
                                            <button 
                                                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200"
                                                onClick={() => setShowAppointmentDialog(true)}
                                            >
                                                অ্যাপয়েন্টমেন্ট
                                            </button>
                                            {doctor.first_visit_rate && (
                                                <div className="text-center">
                                                    <span className="text-xs text-gray-500">প্রথম পরিদর্শন</span>
                                                    <div className="text-sm font-semibold text-green-600">
                                                        ৳{doctor.first_visit_rate}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* No Results Message */}
                {!isLoading && doctors.length === 0 && !error && (
                    <div className="bg-white rounded-lg shadow-md p-6 text-center">
                        <svg className="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <p className="text-gray-500">ডাক্তার খুঁজতে অনুসন্ধান করুন</p>
                    </div>
                )}
            </div>
            {showAppointmentDialog && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
                    <div className="bg-white rounded-lg shadow-lg p-6 max-w-xs w-full text-center">
                        <div className="mb-4 text-lg font-semibold text-gray-800">
                            ০ ১৫৫৮-২৪৩১০৩ নম্বরে কল করুন
                        </div>
                        <button
                            onClick={() => setShowAppointmentDialog(false)}
                            className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                        >
                            বন্ধ করুন
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConsultDoctor; 